module.exports = __webpack_public_path__ + "img/calendar-icon-01.8db05fe7.gif";